export default "__VITE_ASSET__dy0tzxzT__"